import Controller from "./contractor.controller";
import template from "./contractor.html";

const contractor = {
  template,
  controller: Controller,
};

export default contractor;



// WEBPACK FOOTER //
// ./src/pages/contractor/contractor.component.js